import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { TransactionAuthorizationResult } from '@zero/shared/util-models';
import { Observable } from 'rxjs';
import { terminateDepotActions, terminateDepotFeature } from '../+state';
import { Checklist } from '../entities/checklist.entity';

@Injectable({ providedIn: 'root' })
export class TerminateDepotFacade {
  readonly #store = inject(Store);

  public checklist$: Observable<Checklist> = this.#store.select(terminateDepotFeature.selectChecklist);
  public isReady$ = this.#store.select(terminateDepotFeature.selectIsReady);
  public loading$ = this.#store.select(terminateDepotFeature.selectLoading);
  public dataToAuthorize$ = this.#store.select(terminateDepotFeature.selectDataToAuthorize);
  public authSuccess$ = this.#store.select(terminateDepotFeature.selectAuthSuccess);
  public terminationDone$ = this.#store.select(terminateDepotFeature.selectTerminationDone);
  public hasError$ = this.#store.select(terminateDepotFeature.selectHasError);

  public loadChecklist() {
    this.#store.dispatch(terminateDepotActions.loadChecklistState());
  }

  public terminate(reason: string) {
    this.#store.dispatch(terminateDepotActions.terminate({ reason }));
  }

  public handleAuthenticationResult(result: TransactionAuthorizationResult) {
    this.#store.dispatch(terminateDepotActions.handleAuthenticationResult({ result }));
  }

  public checkStatus() {
    this.#store.dispatch(terminateDepotActions.checkStatus());
  }
}
